import React, { useEffect, useState } from 'react'
import Topbar from '../layout/Topbar'
import { useBookStore } from '../../provider/BookStore'
import { useNavigate } from 'react-router-dom';
import api from '../../api/axios';
import { getErrorMessage, logError } from '../../utils/errorHandler';

function Periode() {

    const bookState = useBookStore();
    const book = bookState.book;
    const navigate = useNavigate();

    const [display, setDisplay] = useState('');
    const [weekly, setWeekly] = useState('mon');
    const [monthly, setMonthly] = useState(1);
    const [yearly, setYearly] = useState('jan');
    const [customStart, setCustomStart] = useState(null);
    const [customEnd, setCustomEnd] = useState(null);
    const [msg, setMsg] = useState('');

    useEffect(() => {
        // setBookId(location.state.bookId);
        if (book.id === undefined) {
            navigate('/')
        }

        setDisplay(book.display)
        setWeekly(book.weekly_start)
        setMonthly(book.monthly_start)
        setYearly(book.yearly_start)
        setCustomStart(book.custom_start)
        setCustomEnd(book.custom_end)
    }, []);

    const handleSave = async() => {
        setMsg('');
        try {
            await api.post('/book/save',{
                book_id: book.id,
                title: book.title,
                display: display,
                weekly_start: weekly,
                monthly_start: monthly,
                yearly_start: yearly,
                custom_start: customStart,
                custom_end: customEnd
            })
            // update store agar halaman transaksi & statistik langsung
            // memakai pengaturan periode yang baru (tanpa perlu reload daftar buku)
            bookState.setBook({
                ...book,
                display: display,
                weekly_start: weekly,
                monthly_start: monthly,
                yearly_start: yearly,
                custom_start: customStart,
                custom_end: customEnd
            })
            navigate('/')
        } catch (error) {
            logError('Gagal menyimpan periode:', error);
            setMsg(getErrorMessage(error, 'Gagal menyimpan periode. Silakan coba lagi.'));
        }
    }

    const renderPeriodeStart = () => {
        switch (display) {
            case 'daily':
                return (<></>)
            case 'weekly':
                return (
                    <div className="field">
                        <label className="label">Pilih Hari Pertama</label>
                        <div className="select is-fullwidth">
                            <select value={weekly} onChange={(e) => setWeekly(e.target.value)}>
                                <option value='mon'>Senin</option>
                                <option value='tue'>Selasa</option>
                                <option value='wed'>Rabu</option>
                                <option value='thu'>Kamis</option>
                                <option value='fri'>Jum'at</option>
                                <option value='sat'>Sabtu</option>
                                <option value='sun'>Minggu</option>
                            </select>
                        </div>
                    </div>
                )
            case 'monthly':
                const options = [];
                for (let index = 1; index < 29; index++) {
                    options.push(<option key={index} value={index}>{index}</option>);
                }
                return (
                    <div className="field">
                        <label className="label">Pilih Tanggal Pertama</label>
                        <div className="select is-fullwidth">
                            <select value={monthly} onChange={(e) => setMonthly(parseInt(e.target.value))}>
                                {options}
                            </select>
                        </div>
                    </div>
                )
            case 'yearly':
                return (
                    <div className="field">
                        <label className="label">Pilih Bulan Pertama</label>
                        <div className="select is-fullwidth">
                            <select value={yearly} onChange={(e) => setYearly(e.target.value)}>
                                <option value='jan'>Januari</option>
                                <option value='feb'>Februari</option>
                                <option value='mar'>Maret</option>
                                <option value='apr'>April</option>
                                <option value='may'>Mei</option>
                                <option value='jun'>Juni</option>
                                <option value='jul'>Juli</option>
                                <option value='aug'>Agustus</option>
                                <option value='sep'>September</option>
                                <option value='oct'>Oktober</option>
                                <option value='nov'>November</option>
                                <option value='dec'>Desember</option>
                            </select>
                        </div>
                    </div>
                )
            default: // custom
                return (
                    <div>
                        <div className="field mt-5">
                            <label className="label">Tanggal Mulai</label>
                            <div className="controls">
                                <input type="date" className="input is-fullwidth" placeholder='Tanggal'
                                    value={customStart} onChange={(e) => setCustomStart(e.target.value)} />
                            </div>
                        </div>
                        <div className="field mt-5">
                            <label className="label">Tanggal Berakhir</label>
                            <div className="controls">
                                <input type="date" className="input is-fullwidth" placeholder='Tanggal'
                                    value={customEnd} onChange={(e) => setCustomEnd(e.target.value)} />
                            </div>
                        </div>
                    </div>
                )
        }
    }

    return (
        <div>
            <Topbar
                title={book.title}
                back={() => navigate('/book')}
            />
            <div className='container p-5'>
                <div className="columns is-centered">
                    <div className="column is-5-widescreen is-6-desktop is-7-tablet">

                        <div className='card'>
                            <header className='card-header'>
                                <p className='card-header-title'>Pilih Periode Tampilan</p>
                            </header>
                            <div className='card-content'>
                                <div className="field">
                                    <label className="label">Tampilan</label>
                                    <div className="select is-fullwidth">
                                        <select value={display} onChange={(e) => setDisplay(e.target.value)}>
                                            <option value='daily'>Harian</option>
                                            <option value='weekly'>Mingguan</option>
                                            <option value='monthly'>Bulanan</option>
                                            <option value='yearly'>Tahunan</option>
                                            <option value='custom'>Custom</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="field mt-5">
                                    {renderPeriodeStart()}
                                </div>
                                {msg && <p className="has-text-danger mt-4">{msg}</p>}
                            </div>
                            <footer className='card-footer has-background-primary-30'>
                                <button className='card-footer-item has-text-white'
                                    onClick={() => handleSave()}>
                                    Simpan
                                </button>
                            </footer>
                        </div>



                    </div>
                </div>
            </div>

        </div>
    )
}

export default Periode
